import { Contact } from 'src/app/contact-management/groups-management/models/contact.model';
import { isNull } from '../../search/musimap-filters/musimap-common/musimap-common.utils';
import { formatPerson } from '../../shared/utils/utils';

const TEXT_NODE_TYPE = 3;

export function formatContact(contact: Contact, companiesOnly: boolean = false): string | null {
  let displayValue: string | null = null;
  if (contact) {
    const contactPerson: string = companiesOnly ? '' : formatPerson(contact.firstName, contact.lastName);
    const companyName: string = contact.company || contact.companyName;
    if (companyName || contactPerson) {
      if (contactPerson) {
        displayValue = `${contactPerson}`;
      } else {
        displayValue = `${companyName}`;
      }
    } else {
      displayValue = `${contact.email}`;
    }
  }

  return displayValue;
}

export function htmlToText(htmlContent: string | null | any): string {
  if (isNull(htmlContent)) {
    return null;
  } else {
    const whiteSpaceCharCodeRegExp = /&nbsp;/gi;
    const charCodesRegExp = /&[a-z0-9!@#$]*;/gi;
    const blockRegExp = /<div>/gi;
    const paragraphRegExp = /<p/gi;
    const newLineRegExp = /<br>/gi;
    const styleTagRegExp = /<style[\s\S]*<\/style>/gi;
    const migratedDataRegExp = /(Begin|End) Migrated Data/gi;
    const replaceCharCodes = (str: string, replaceVal: string = ' '): string =>
      str.replace(whiteSpaceCharCodeRegExp, replaceVal).replace(charCodesRegExp, replaceVal);

    const ninjaElem = document.createElement('ninja-element');
    const textFields: string[] = [];

    const parseChildNodes = elem => {
      Array.from(elem.childNodes).forEach((childNode: ChildNode) => {
        if (childNode.childNodes.length) {
          parseChildNodes(childNode);
        } else {
          let text = childNode.textContent;
          if (
            childNode.nodeType !== TEXT_NODE_TYPE ||
            text === '' ||
            // text.match(/\n+/) ||
            text === '\u00a0' ||
            text === '\u200B'
          ) {
            text = childNode.textContent.replace('\n', '').trim();
          }
          if (text.length) {
            textFields.push(replaceCharCodes(text));
          }
        }
      });
    };

    ninjaElem.innerHTML = htmlContent
      .replace(newLineRegExp, '\n')
      .replace(blockRegExp, '\n<div>')
      .replace(paragraphRegExp, '\n<p')
      .replace(migratedDataRegExp, '')
      .replace(styleTagRegExp, '');

    parseChildNodes(ninjaElem);
    ninjaElem.remove();

    return textFields.filter(str => str && !/^"?\n*$/.test(str)).join('\n');
  }
}
